import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';

import CancelledBookingList from '../../../components/SiteAdmin/CancelledTrips/CancelBookingList';
import Loader from '../../../components/Common/Loader/Loader';

import messages from '../../../locale/messages';
import getCancelledQuery from './getCancelBookings.graphql';
import { withQuery } from '../../../hoc/withGraphql';

export class CancelledBooking extends Component {

    static defaultProps = {
        booking: {
            loading: true
        }
    }

    render() {
        const { formatMessage } = this.props.intl;
        const { cancelledTrips, cancelledTrips: { loading } } = this.props;

        return (
            <Loader type={"page"} show={loading}>
                <h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.manageCancelledBookings)}</h1>
                {!loading && <CancelledBookingList cancelledTrips={cancelledTrips} loading={loading} />}
            </Loader>
        );
    }
}

export default compose(
    injectIntl,
    withQuery(getCancelledQuery, {
        name: 'cancelledTrips',
        options: {
            variables: {
                currentPage: 1,
                searchList: ''
            },
            fetchPolicy: 'network-only',
            ssr: false
        }
    })
)(CancelledBooking);
